import { ErrorSharp } from '@material-ui/icons';
import checkInputs from 'utils/checkInputs';
import { stringToNumber } from "utils/parseInput";

const validations = {
    editSecuencial: function validationEditSecuencial(updatedSecuencial) {
        const errors = {};
        if (!checkInputs.notNull(updatedSecuencial.codigoSucursal)) {
            errors.codigoSucursal = 'El código del establecimiento es necesario.';
        } else if (!checkInputs.isNumeric(updatedSecuencial.codigoSucursal)) {
            errors.codigoSucursal = 'Solo ingrese números.';
        } else if (updatedSecuencial.codigoSucursal.length > 4) {
            errors.codigoSucursal = 'No ingrese más de 4 caracteres.';
        }


        if (!checkInputs.notNull(updatedSecuencial.puntoFacturacion)) {
            errors.puntoFacturacion = 'El punto de emisión es necesario.';
        } else if (!checkInputs.isNumeric(updatedSecuencial.puntoFacturacion)) {
            errors.puntoFacturacion = 'Solo ingrese números.';
        } else if (updatedSecuencial.puntoFacturacion.length > 3) {
            errors.puntoFacturacion = 'No ingrese más de 3 caracteres.';
        }

        if (!checkInputs.notNull(updatedSecuencial.direccion)) {
            errors.direccion = 'La dirección es necesaria.';
        } else if (!checkInputs.isAlphanumeric(updatedSecuencial.direccion)) {
            errors.direccion = 'No ingrese caracteres especiales.';
        } else if (updatedSecuencial.direccion.length > 300) {
            errors.direccion = 'No ingrese más de 300 caracteres.';
        }

        let regexCoordenadas = new RegExp("[+-]{0,1}[0-9]{1,2}[.]{1}[0-9]{4,6}[,]{1}[+-]{0,1}[0-9]{1,2}[.]{1}[0-9]{4,6}");
        if (!checkInputs.notNull(updatedSecuencial.coordenadaSucursal)) {
            errors.coordenadaSucursal = 'La coordenada es necesaria.';
        } else if (updatedSecuencial.coordenadaSucursal.length > 22) {
            errors.coordenadaSucursal = 'No ingrese más de 22 caracteres.';
        } else if (!regexCoordenadas.test(updatedSecuencial.coordenadaSucursal)) {
            errors.coordenadaSucursal = 'El formato de la coordenada de la sucursal no es correcto.';
        }
        return errors;
    },
    addSecuencial: function validationAddUser(secuencial) {
        const errors = {};
        if (typeof secuencial.codigoSucursal === 'undefined') {
            errors.codigoSucursal = 'El código del establecimiento es necesario.';
        } else if (!checkInputs.notNull(secuencial.codigoSucursal)) {
            errors.codigoSucursal = 'El código del establecimiento es necesario.';
        } else if (!checkInputs.isNumeric(secuencial.codigoSucursal)) {
            errors.codigoSucursal = 'Solo ingrese números.';
        } else if (secuencial.codigoSucursal.length > 4) {
            errors.codigoSucursal = 'No ingrese más de 4 caracteres.';
        }

        if (typeof secuencial.puntoFacturacion === 'undefined') {
            errors.puntoFacturacion = 'El punto de emisión es necesario.';
        } else if (!checkInputs.notNull(secuencial.puntoFacturacion)) {
            errors.puntoFacturacion = 'El punto de emisión es necesario.';
        } else if (!checkInputs.isNumeric(secuencial.puntoFacturacion)) {
            errors.puntoFacturacion = 'Solo ingrese números.';
        } else if (secuencial.puntoFacturacion.length > 3) {
            errors.puntoFacturacion = 'No ingrese más de 3 caracteres.';
        }

        if (typeof secuencial.direccion === 'undefined') {
            errors.direccion = 'La dirección es necesaria.';
        } else if (!checkInputs.notNull(secuencial.direccion)) {
            errors.direccion = 'La dirección es necesaria.';
        } else if (!checkInputs.isAlphanumeric(secuencial.direccion)) {
            errors.direccion = 'No ingrese caracteres especiales.';
        } else if (secuencial.direccion.length > 300) {
            errors.direccion = 'No ingrese más de 300 caracteres.';
        }

        let regexCoordenadas = new RegExp("[+-]{0,1}[0-9]{1,2}[.]{1}[0-9]{4,6}[,]{1}[+-]{0,1}[0-9]{1,2}[.]{1}[0-9]{4,6}");
        if (!checkInputs.notNull(secuencial.coordenadaSucursal)) {
            errors.coordenadaSucursal = 'La coordenada es necesaria.';
        } else if (secuencial.coordenadaSucursal.length > 22) {
            errors.coordenadaSucursal = 'No ingrese más de 22 caracteres.';
        } else if (!regexCoordenadas.test(secuencial.coordenadaSucursal)) {
            errors.coordenadaSucursal = 'El formato de la coordenada de la sucursal no es correcto.';
        }
        return errors;
    },
    handleNumSecuencialSucursal: function handleChangeSecuencialSucursal(numSecuencial) {
        let newNumSecuencial = stringToNumber(numSecuencial);

        if (newNumSecuencial === 0) {
            return null;
        } else if (newNumSecuencial < 10) {
            return "000" + newNumSecuencial;
        } else if (newNumSecuencial < 100) {
            return "00" + newNumSecuencial;
        } else if (newNumSecuencial < 1000) {
            return "0" + newNumSecuencial;
        } else {
            return "" + newNumSecuencial;
        }
    },
    handleNumSecuencialPunto: function handleChangeSecuencialPunto(numSecuencial) {
        let newNumSecuencial = stringToNumber(numSecuencial);

        if (newNumSecuencial === 0) {
            return null;
        } else if (newNumSecuencial < 100) {
            return "00" + newNumSecuencial;
        } else if (newNumSecuencial < 1000) {
            return "0" + newNumSecuencial;
        } else {
            return "" + newNumSecuencial;
        }
    },
    validateCoordinates: function isValidCoordinates(coordinates) {
        if (!coordinates.match(/^(\-?\d+(\.\d+)?),*(\-?\d+(\.\d+)?)$/)) {
            return false;
        }
        const [latitude, longitude] = coordinates.split(",");
        return (latitude > -90 && latitude < 90 && longitude > -180 && longitude < 180);
    }
}

export default validations;